<template>
  <div
    class="smardie-text-area"
    :class="{ disabled: disabled, error: error }"
  >
    <textarea
      :rows="rows"
      :placeholder="placeholder"
      :value="modelValue"
      :disabled="disabled"
      :readonly="readonly"
      :name="name"
      :id="inputId"
      :class="{ error: error }"
      @input="onInput"
      @keyup="onKeyup"
      @change="onChange"
      @blur="$emit('blur', $event)"
      @focus="$emit('focus', $event)"
    />
  </div>
</template>

<script>
export default {
  name: 'TextArea',
  compatConfig: {
    COMPONENT_V_MODEL: false
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    rows: {
      type: [Number, String],
      default: 4
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    inputId: {
      type: String,
      default: ''
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onInput: function (event) {
      this.$emit('update:modelValue', event.target.value)
    },
    onKeyup: function (event) {
      this.$emit('keyup', event)
    },
    onChange: function (event) {
      this.$emit('change', event)
    }
  }
}
</script>
